// Tipos e helpers da consola de help desk do painel de administração da plataforma.

import type { EntityDocument } from '../../shared/utils/types'
import { TONE } from '../../shared/theme/legacyTones'

export type HelpdeskStatus = 'ABERTO' | 'EM_ANALISE' | 'RESOLVIDO' | 'FECHADO'

/** Anexo de um pedido — GET /api/admin/helpdesk/tickets/{id}/anexos (mesma forma que os restantes anexos). */
export type HelpdeskAnexo = EntityDocument

/** GET /api/admin/helpdesk/tickets — linha da listagem. */
export interface HelpdeskTicketItem {
    id: string
    tenantId: string
    tenantNome: string | null
    titulo: string
    status: HelpdeskStatus
    abertoPorNome: string | null
    criadoEm: string
    fechadoEm: string | null
}

/** GET /api/admin/helpdesk/tickets/{id} — detalhe. */
export interface HelpdeskTicketDetail {
    id: string
    tenantId: string
    tenantNome: string | null
    titulo: string
    descricao: string
    status: HelpdeskStatus
    abertoPorNome: string | null
    abertoPorEmail: string | null
    criadoEm: string
    atualizadoEm: string | null
    fechadoEm: string | null
}

/** GET /api/admin/helpdesk/resumo — contagem por estado. */
export interface HelpdeskResumo {
    aberto: number
    emAnalise: number
    resolvido: number
    fechado: number
    total: number
}

export const HELPDESK_STATUSES: HelpdeskStatus[] = ['ABERTO', 'EM_ANALISE', 'RESOLVIDO', 'FECHADO']

export const HELPDESK_STATUS_LABEL: Record<HelpdeskStatus, string> = {
    ABERTO: 'Aberto',
    EM_ANALISE: 'Em análise',
    RESOLVIDO: 'Resolvido',
    FECHADO: 'Fechado',
}

export const HELPDESK_STATUS_TONE: Record<HelpdeskStatus, { bg: string; color: string }> = {
    ABERTO: TONE.neutral,
    EM_ANALISE: TONE.info,
    RESOLVIDO: TONE.success,
    FECHADO: TONE.muted,
}

/** Chave do resumo correspondente a cada estado (para as chips-filtro do cabeçalho). */
export const HELPDESK_RESUMO_KEY: Record<HelpdeskStatus, keyof HelpdeskResumo> = {
    ABERTO: 'aberto',
    EM_ANALISE: 'emAnalise',
    RESOLVIDO: 'resolvido',
    FECHADO: 'fechado',
}

export function formatDate(iso: string | null | undefined): string {
    if (!iso) return '—'
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return '—'
    return d.toLocaleDateString('pt-PT', { day: '2-digit', month: 'short', year: 'numeric' })
}

/** "342 KB", "1.4 MB" — vazio quando o tamanho é desconhecido. */
export function formatBytes(bytes: number | null | undefined): string {
    if (bytes == null || Number.isNaN(bytes)) return ''
    if (bytes < 1024) return `${bytes} B`
    const kb = bytes / 1024
    if (kb < 1024) return `${kb.toFixed(kb < 10 ? 1 : 0)} KB`
    return `${(kb / 1024).toFixed(1)} MB`
}
